import { map } from 'rxjs/operators';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  PLATFORM_ID,
  Inject,
  ViewChild,
  ViewChildren,
  AfterContentChecked,
  QueryList
} from '@angular/core';
import { IAppState } from '@app/store';
import { Store } from '@ngrx/store';
import { ContentRepositoryService } from '@app/core/services/content/content-repository.service';
import { INavigationItem, formatToNavigationItem, PageData } from '@app/core/header/components/main-nav/navigation';
import { isPlatformServer } from '@angular/common';
import { SetCatalogPageNumber } from '@app/+catalog/store';
import { UnderlineDirective } from '@app/core/header/directives/underline/underline.directive';

@Component({
  selector: 'vc-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent implements OnInit, AfterContentChecked {
  @Input()
  directShippingEligible: boolean;
  @Output()
  closeMenuMobileEvent: EventEmitter<null> = new EventEmitter();
  @ViewChild(UnderlineDirective, { static: false })
  _underline: UnderlineDirective;
  @ViewChildren('ref') _currentRef: QueryList<any>;
  private _selectedIndex = 0;
  private _selectedIndexChanged = false;

  deviceIsLgUp: boolean;
  timerMenuLevel2: number;
  mainNav: INavigationItem[];
  jsonNav: JSON;
  pageData: PageData = {};
  eventMnemonics = ['black-firday', 'winterdeals', 'summer-sales'];
  isServer = false;

  constructor(
    private store: Store<IAppState>,
    private contentRepository: ContentRepositoryService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isServer = isPlatformServer(this.platformId);
  }

  ngOnInit() {
    this.initDevice();
    this.initRouting();
    this.setNavigation();
  }

  private initDevice(): void {
    this.store.select('device').subscribe(
      res => {
        this.deviceIsLgUp = res && res.isLgUp;
      },
      () => {
        /* Silently catch exception */
      }
    );
  }

  private initRouting(): void {
    this.store
      .select('router')
      .pipe(map(resp => resp.state))
      .subscribe(
        resp => {
          if (resp && resp.queryParams && resp.queryParams.q) {
            this.closeMenu();
          }
        },
        err => {
          // Silently catch exception
        }
      );
  }

  resetMenuStateFromLevel(level) {
    if (!level) {
      return;
    }
    const newList = level.children ? level.children : level;
    if (newList && newList.length > 0) {
      for (let i = 0; i < newList.length; i++) {
        if (newList[i]) {
          newList[i].active = false;
          level = newList;
          this.resetMenuStateFromLevel(level[i]);
        }
      }
    }
  }

  mouseoverlevel1Title(categoryIndex) {
    if (this.mainNav[categoryIndex].children && this.mainNav[categoryIndex].children.length > 0) {
      this.openLevel2_onDesktop(categoryIndex);
    } else {
      if (this.deviceIsLgUp) {
        this.resetMenuStateFromLevel(this.mainNav);
      }
    }
  }

  openLevel2_onDesktop(categoryIndex) {
    if (this.deviceIsLgUp) {
      this.timerMenuLevel2 = <any>setTimeout(() => {
        this.resetMenuStateFromLevel(this.mainNav);
        this.mainNav[categoryIndex].active = true;
      }, 100);
    }
  }

  clearTimeoutLevel2() {
    clearTimeout(this.timerMenuLevel2);
  }

  toggleLevel2_onMobile(categoryIndex, isActive, event) {
    if (!this.deviceIsLgUp) {
      event.preventDefault();
      const level2 = this.mainNav[categoryIndex];
      level2.active = !isActive;
      if (level2.active) {
        this.scrollMenuToSeeSubcategories(event);
      }
      // close submenus level3
      if (isActive) {
        this.resetMenuStateFromLevel(level2);
      }
    }
  }

  hideLevel2_onDesktop(categoryIndex) {
    if (this.deviceIsLgUp) {
      this.mainNav[categoryIndex].active = false;
    }
  }

  toggleLevel3_onMobile(categoryIndex, subCategoryIndex, isActive, hasContent, event) {
    if (hasContent) {
      event.preventDefault();
      this.mainNav[categoryIndex].children[subCategoryIndex].active = !isActive;
      if (this.mainNav[categoryIndex].children[subCategoryIndex].active) {
        this.scrollMenuToSeeSubcategories(event);
      }
    } else {
      this.closeMobileMenu();
    }
  }

  onClickLevel2Link(categoryIndex, isActive, event, closeMenu = true) {
    if (this.mainNav[categoryIndex].children && this.mainNav[categoryIndex].children.length > 0) {
      if (this.deviceIsLgUp && closeMenu) {
        const levelToClose = this.mainNav[categoryIndex];
        this.resetMenuStateFromLevel(levelToClose);
        this.closeMenu();
      } else {
        this.toggleLevel2_onMobile(categoryIndex, isActive, event);
      }
    } else {
      this.closeMenu();
    }
  }

  onClickLevel3Link(categoryIndex, subCategoryIndex, isActive, hasContent, event) {
    if (this.deviceIsLgUp) {
      const levelToClose = this.mainNav[categoryIndex];
      this.resetMenuStateFromLevel(levelToClose);
      this.closeMenu();
    } else {
      this.toggleLevel3_onMobile(categoryIndex, subCategoryIndex, isActive, hasContent, event);
    }
  }

  closeMenu() {
    if (this.deviceIsLgUp) {
      const levelToClose = this.mainNav;
      this.resetMenuStateFromLevel(levelToClose);
    } else {
      this.closeMobileMenu();
    }
  }

  closeMobileMenu() {
    this.closeMenuMobileEvent.emit();
  }

  scrollMenuToSeeSubcategories(elem) {
    const linkPos = elem.pageY;
    let newScrollPos;
    const el__mobileMenu = document.getElementsByClassName('secondLine__innerWrapper')[0];
    const mobileNavScrollTop = el__mobileMenu.scrollTop;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    if (linkPos > (viewportHeight * 2) / 3) {
      newScrollPos = mobileNavScrollTop + 100;
      this.scrollTo(el__mobileMenu, newScrollPos, 400);
    }
  }

  scrollTo(element, to, duration) {
    // https://gist.github.com/andjosh/6764939
    const start = element.scrollTop;
    const change = to - start;
    let currentTime = 0;
    const increment = 20;

    function easeInOutQuad(t, b, c, d) {
      t /= d / 2;
      if (t < 1) {
        return (c / 2) * t * t + b;
      }
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    }

    function animateScroll() {
      currentTime += increment;
      const val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    }
    animateScroll();
  }

  public resetCatalogPage() {
    this.store.dispatch(new SetCatalogPageNumber({ pageNumber: 0 }));
  }

  public subscribePageParams(): void {
    this.store.select('header').subscribe(
      res => {
        this.pageData = res['pageParams'];
        this.buildNavigation();
      },
      () => {}
    );
  }

  /**
   * Init navigation
   */
  public setNavigation() {
    this.contentRepository.getHeader().subscribe(
      json => {
        this.jsonNav = json;
        if (this.isServer) {
          this.subscribePageParams();
        } else {
          this.buildNavigation();
        }
      },
      () => {}
    );
  }

  private buildNavigation(): void {
    this.mainNav = Object.keys(this.jsonNav).map(itemJson =>
      formatToNavigationItem(this.jsonNav[itemJson], this.isServer, this.pageData)
    );
  }

  /**
   * Underline Menu
   */
  public mouseoverUnderline(i: number) {
    if (this.deviceIsLgUp) {
      this._selectedIndexChanged = this._selectedIndex !== i;
      this._selectedIndex = i;
      this.alignUnderlineToSelectedTab();
    }
  }

  public mouseoutUnderline() {
    this._underline.hide();
  }

  alignUnderlineToSelectedTab(): void {
    const selectedLi =
      this._currentRef && this._currentRef.length
        ? this._currentRef.toArray()[this._selectedIndex].nativeElement
        : null;
    if (selectedLi) {
      this._underline.alignToElement(selectedLi);
    }
  }

  ngAfterContentChecked(): void {
    // If the selected index has changed, scroll to the label and check if the scrolling controls
    // should be disabled.
    if (this._selectedIndexChanged) {
      this._selectedIndexChanged = false;
    }
  }
}
